export default "__VITE_ASSET__L5w6jPgs__"